import React from 'react';
import styled from 'styled-components';

const AppsContainer = styled.div`
  max-width: 1000px;
  margin: 0 auto;
  padding: 2rem;
  background: linear-gradient(135deg, #6b46c1 0%, #4338ca 25%, #1e1b4b 75%, #000000 100%);
  min-height: 100vh;
  color: #e2e8f0;
`;

const AppsHeader = styled.h1`
  color: #ffffff;
  text-align: center;
  margin-bottom: 2rem;
  text-shadow: 0 0 10px rgba(139, 92, 246, 0.5);
  font-size: 2.5rem;
`;

const AppsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  margin-top: 2rem;
`;

const AppCard = styled.div`
  background: rgba(255, 255, 255, 0.05);
  padding: 2rem;
  border-radius: 15px;
  border: 1px solid rgba(139, 92, 246, 0.3);
  backdrop-filter: blur(10px);
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-5px);
    border-color: #8b5cf6;
    box-shadow: 0 15px 35px rgba(139, 92, 246, 0.3);
  }
`;

const AppIcon = styled.div`
  font-size: 3rem;
  margin-bottom: 1rem;
  text-align: center;
`;

const AppTitle = styled.h3`
  color: #a78bfa;
  margin-bottom: 1rem;
  font-size: 1.5rem;
  text-align: center;
`;

const AppDescription = styled.p`
  color: #cbd5e1;
  line-height: 1.6;
  margin-bottom: 1.5rem;
`;

const AppTech = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 1.5rem;
`;

const TechTag = styled.span`
  background: rgba(139, 92, 246, 0.2);
  color: #c4b5fd;
  padding: 0.25rem 0.75rem;
  border-radius: 12px;
  font-size: 0.85rem;
  border: 1px solid rgba(139, 92, 246, 0.3);
`;

const AppLink = styled.a`
  display: inline-block;
  background: rgba(139, 92, 246, 0.2);
  color: #a78bfa;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  text-decoration: none;
  font-weight: 600;
  border: 1px solid rgba(139, 92, 246, 0.3);
  transition: all 0.3s ease;

  &:hover {
    background: rgba(139, 92, 246, 0.3);
    color: #c4b5fd;
    transform: translateX(5px);
  }
`;

const Apps: React.FC = () => {
  return (
    <AppsContainer>
      <AppsHeader>My Apps & Projects</AppsHeader>
      <AppsGrid>
        <AppCard>
          <AppIcon>🎵</AppIcon>
          <AppTitle>Audio to Sheet Music Converter</AppTitle>
          <AppDescription>
            Convert audio files or live recordings into sheet music and guitar tab notation.
            Upload MP3, WAV, or M4A files, or record directly in your browser. Download
            results as PDF or MusicXML format.
          </AppDescription>
          <AppTech>
            <TechTag>React</TechTag>
            <TechTag>TypeScript</TechTag>
            <TechTag>Node.js</TechTag>
            <TechTag>VexFlow</TechTag>
            <TechTag>Tone.js</TechTag>
            <TechTag>Web Audio API</TechTag>
          </AppTech>
          <AppLink href="/audio-converter">Launch App</AppLink>
        </AppCard>

        <AppCard>
          <AppIcon>🎨</AppIcon>
          <AppTitle>Voice Drawing App</AppTitle>
          <AppDescription>
            Draw shapes on a canvas using voice commands or text input! Create circles,
            squares, triangles, stars, and hearts with natural language. Control colors
            and sizes with your voice.
          </AppDescription>
          <AppTech>
            <TechTag>React</TechTag>
            <TechTag>Vite</TechTag>
            <TechTag>Web Speech API</TechTag>
            <TechTag>Canvas API</TechTag>
          </AppTech>
          <AppLink href="/voice-draw">Launch App</AppLink>
        </AppCard>

        <AppCard>
          <AppIcon>🌐</AppIcon>
          <AppTitle>Portfolio Website</AppTitle>
          <AppDescription>
            This very site you're on! A modern React-based portfolio showcasing my work,
            hobbies, and thoughts with a beautiful purple gradient theme.
          </AppDescription>
          <AppTech>
            <TechTag>React</TechTag>
            <TechTag>TypeScript</TechTag>
            <TechTag>Styled Components</TechTag>
          </AppTech>
          <AppLink href="/">View Site</AppLink>
        </AppCard>

        <AppCard>
          <AppIcon>💻</AppIcon>
          <AppTitle>Coming Soon</AppTitle>
          <AppDescription>
            More amazing applications and tools are on the way. Check back soon to see
            what I'm building next!
          </AppDescription>
          <AppTech>
            <TechTag>In Development</TechTag>
          </AppTech>
        </AppCard>
      </AppsGrid>
    </AppsContainer>
  );
};

export default Apps;
